import { Attachment, DataSource, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutComments extends Layout {
    attachmentAttachment: Attachment;
    labelComments: Label;
    panelMain: Panel;
    panelOrderFields: Panel;
    sourceComments: DataSource;
    switchCopyToOrder: Switch;
    switchDispatch: Switch;
    textComments: Textbox;
    textboxCommentTypeId: Textbox;
    textboxEnteredDate: Textbox;
    textboxEnteredUserId: Textbox;
    textboxOrderCommentType: Textbox;
}
